"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Qualifier = void 0;
var Qualifier;
(function (Qualifier) {
    Qualifier["HOME"] = "home";
    Qualifier["AWAY"] = "away";
})(Qualifier || (exports.Qualifier = Qualifier = {}));
